<!--
 * @Descripttion: 实物分销 - 首页
 * @Author: Biwenliang
 * @version: 
 * @Date: 2020-07-27 20:06:11
 * @LastEditTime: 2020-12-17 20:44:01
-->

<template>
  <section class="physical-home-container">
    <SearchHead type="physical" placeholder="输入关键字或商品链接、口令" />
    <Banner />
    <HomeDocument />
    <HomeHot />
    <HomeDowntick />
    <!-- <HomeTimeLimit /> -->
  </section>
</template>

<script>
import SearchHead from "@/components/searchHead";
import { round } from "@/utils";
import Banner from "./components/banner";
import HomeHot from "./components/homeHot";
import HomeDowntick from "./components/homeDowntick";
import HomeTimeLimit from "./components/homeTimeLimit";
import HomeDocument from "./components/homeDocument";
export default {
  data() {
    return {};
  },
  components: {
    SearchHead,
    Banner,
    HomeHot,
    HomeDowntick,
    HomeTimeLimit,
    HomeDocument,
  },
  methods: { round },
};
</script>

<style lang="scss" scoped>
.physical-home-container {
  background: #f2f2f2;
}
</style>
